import React, { createContext, useContext } from 'react';
import type { FC, ReactNode } from 'react';
import type { ErrorReporter } from './error-reporter.js';

const ErrorReporterContext = createContext<ErrorReporter | null>(null);

interface Props {
  value: ErrorReporter;
  children: ReactNode;
}

export const ErrorReporterProvider: FC<Props> = (props) => (
  <ErrorReporterContext.Provider {...props} />
);

export const useErrorReporter = (): ErrorReporter => {
  const context = useContext(ErrorReporterContext);
  if (context == null) {
    throw new Error(
      'useErrorReporter() cannot be used without an <ErrorReporterProvider>'
    );
  }
  return context;
};
